import { useNavigate } from 'react-router';
import intl from 'components/i18n/ReactIntlWrapper';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, IconButton } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import WorkflowActionsBar from '../Workflow/WorkflowActionsBar';
import { WorkflowProvider } from 'components/Workflow/WorkflowContext';
import { formatDateInvoices } from '../../common/utils';
import { WorkflowStatusChip } from '../common/WorkflowStatusChip';

const InvoicesListAccountsPayable = ({
  searchResult,
  isValidating,
  loading,
  paginationModel,
  onPaginationModelChange,
  sortModel,
  onSortModelChange,
  WorkflowModuleId
}) => {
  const navigate = useNavigate();

  const columns = [];

  const handleInvoiceDetail = (invoiceID, jobId) => {
    if (isValidating) {
      navigate(`/accountspayable/validate/${jobId}`);
    } else {
      navigate(`/invoice/detail/${invoiceID}`);
    }
  };
  const handleSave = () => {};

  columns.push(
    {
      field: 'date',
      headerName: intl.get('invoicesList.date'),
      width: 250,
      flex: 1,
      renderCell: (params) => <>{formatDateInvoices(params.row.date)}</>,
    },
    {
      field: 'number',
      headerName: intl.get('invoicesList.invoice.number'),
      width: 250,
      flex: 1,
    },
    {
      field: 'amount',
      headerName: intl.get('invoicesList.amount'),
      width: 250,
      flex: 1,
    },
    {
      field: 'status',
      headerName: intl.get('invoicesList.status'),
      width: 250,
      flex: 1,
      renderCell: (params) => (
        <WorkflowStatusChip stateId={params.row.idWorkflowState} />
      ),
    }
  );

  columns.unshift({
    field: 'name',
    headerName: intl.get('invoicesList.name'),
    width: 250,
    flex: 1,
    valueGetter: (value, row) => {
      return isValidating ? row.senderName : row.from;
    },
    renderCell: (params) => (
      <>
        {isValidating
          ? params.row.senderName === null || params.row.senderName === ''
            ? '-'
            : params.row.senderName
          : params.row.from === null || params.row.from === ''
            ? '-'
            : params.row.from}
      </>
    ),
  });

  if (!isValidating) {
    columns.push({
      field: 'id',
      headerName: intl.get('invoicesList.invoice.id'),
      width: 250,
      flex: 1,
    });

    columns.push({
      field: 'workflowActions',
      headerName: intl.get('invoicesList.actions'),
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <WorkflowActionsBar
          viewMode="icons"
          onActionClick={handleSave}
          id={params.row.id}
          stateId={params.row.idWorkflowState}
          loading={loading}
        />
      ),
    });
  }

  columns.push({
    field: 'actions',
    headerName: intl.get('invoicesList.detail'),
    width: 150,
    sortable: false,
    renderCell: (params) => (
      <Box display="flex" justifyContent="center">
        <IconButton onClick={() => handleInvoiceDetail(params.row.id, params.row.jobId)}>
          <VisibilityIcon />
        </IconButton>
      </Box>
    ),
  });

  return (
    <>
        <Box style={{ width: '100%', display: 'flex' }}>
          <WorkflowProvider moduleId={WorkflowModuleId}>
            <DataGrid
              rows={searchResult?.queryResult || []}
              getRowId={(row) => (row.id === 0 ? row.jobId : row.id)}
              columns={columns}
              loading={loading}
              rowCount={searchResult?.totalRecords || 0}
              paginationModel={paginationModel}
              onPaginationModelChange={onPaginationModelChange}
              sortModel={sortModel}
              onSortModelChange={onSortModelChange}
              pageSizeOptions={[5, 10, 20]}
              paginationMode="client"
              sortingMode="client"
            />
          </WorkflowProvider>
      </Box>
    </>
  );
};

export default InvoicesListAccountsPayable;
